module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "btn btn-sm btn-info center-block pull-left",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.goBack()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-left"
  }), _vm._v("  Voltar\n")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e7b086b2","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/elements/GoBackButton.vue
// module id = 712
// module chunks = 1